<template>
    <div id="jxjl">
        <headTop :id="id" @topback="topback"></headTop>
        <detailTop :name="name" :text="text" :detailid="detailid"></detailTop>
        <detailBread :breadName="breadName"></detailBread>
        <div class="wsbxContent">
            <div class="wsbxContent_">
                <div class="wsbxContent_1 jxjlcontent clearfix">
                    <div class="left">
                        <h3><span>多维度信息管理</span> <i class="wsbxh3"></i></h3>
                        <div class="left_text jxjluleft_text clearfix">
                            <ul class="jxjlul1">
                                <li>人员信息管理</li>
                                <li>考核分组管理</li>
                                <li>人员类型管理</li>
                                <li>租赁外挂工资管理</li>
                                <li>考核文件管理</li>
                            </ul>
                            <ul class="jxjlul2">
                                <li>领导岗位级别及津贴管理</li>
                                <li>各考核分组考核奖额度管理</li>
                                <li>人员绩效奖励管理</li>
                                <li>发放状态管理</li>
                            </ul>
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
                <div class="wsbxContent_2">
                    <div class="left jxjluright_text"></div>
                    <div class="right ">
                        <h3><span>便捷录入绩效奖励</span> <i class="xsdch2"></i></h3>
                        <div class="left_text">
                            <h3>绩效奖励的录入：</h3>
                            <p>分组额度计算和提醒；</p>
                            <p>考核材料管理；</p>
                            <p>岗位津贴、外挂工资、月考核奖、<br> 其他等的自动计算</p>
                        </div>
                    </div>
                </div>
                <div class="wsbxContent_3">
                    <div class="left">
                        <h3><span>审核规范、安全可靠</span> <i class="jxjlh3"></i></h3>
                        <div class="left_text">
                            <h3>每月考核奖录入后：</h3>
                            <ul class="jxjlul3 clearfix">
                                <li>1.考核工作组多人确认通过 <br>2.考核分组领导审核</li>
                                <li>3.汇总导出 <br>4.绩效奖励发放完成</li>
                            </ul>
                           <p>多人审查，操作留痕，安全可靠 <br> 多条汇总自动计算，高效快捷</p>
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '绩效奖励分配系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '绩效奖励分配系统'
        },
        {
            name: 'description',
            content: '绩效奖励分配系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
            detailid:3,
            name:'绩效奖励分配系统',
            text:'绩效奖励分配系统解决后勤人员各类绩效奖励的录入、考核小组确认及领导审核、汇总发放过程，提高后勤各类绩效奖励的计算和发放效率，并规范发放过程。',
            breadName:'绩效奖励分配系统'
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>


// WEBPACK FOOTER //
// src/pages/jxjl.vue